export const removeEmpty = (obj: {}) =>
  Object.fromEntries(Object.entries(obj).filter(([_, v]) => v));

export const getArrayOfSameKeys = (data: {}[], key: string) => {
  const arr: string[] = [];
  data?.map((object: any) => arr.push(object[key]));
  return arr;
};
